var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo flex items-center",attrs:{"to":{ name: 'main' }}},[_c('img',{attrs:{"alt":"Fairpay","src":require("@/assets/logo.svg")}}),_c('span',{staticClass:"tablet:text-base text-sm laptop:text-xl text-blue-text font-bold break-words pr-2"},[_vm._v("FAIRPAY PARTNERS")])])
}
var staticRenderFns = []

export { render, staticRenderFns }